import apiClient, { ApiResponse } from '../api/client';
import { DashboardStats } from '../types/models';

export interface DashboardFilters {
  start_date?: string;
  end_date?: string;
  date_filter?: string;
  module_id?: number;
}

class DashboardService {
  private baseUrl = '/admin/county/dashboard';

  // Get complete dashboard data
  async getStats(filters?: DashboardFilters): Promise<ApiResponse<DashboardStats>> {
    const params = new URLSearchParams();
    if (filters?.date_filter) params.append('date_filter', filters.date_filter);
    if (filters?.start_date) params.append('start_date', filters.start_date);
    if (filters?.end_date) params.append('end_date', filters.end_date);
    if (filters?.module_id) params.append('module_id', filters.module_id.toString());

    const queryString = params.toString();
    return apiClient.get<DashboardStats>(
      `${this.baseUrl}${queryString ? `?${queryString}` : ''}`
    );
  }

  // Get filtered dashboard data (AJAX endpoint)
  async getFilteredData(filters?: DashboardFilters): Promise<ApiResponse<DashboardStats>> {
    const params = new URLSearchParams();
    if (filters?.date_filter) params.append('date_filter', filters.date_filter);
    if (filters?.start_date) params.append('start_date', filters.start_date);
    if (filters?.end_date) params.append('end_date', filters.end_date);

    const queryString = params.toString();
    return apiClient.get<DashboardStats>(
      `${this.baseUrl}/filtered-data${queryString ? `?${queryString}` : ''}`
    );
  }
}

export const dashboardService = new DashboardService();
export default dashboardService;
